export default __webpack_public_path__ + "static/media/hhm-vertlanding.8102ba09.gif";